import {
  getGetOrganizationResponseMock as lsGetOrganizationResponseMock,
  OrganizationResponse as LsOrganizationResponse,
} from '@backend';
import {fake} from '@fixtures/fake';
import {getGetOrganizationResponseMock, OrganizationResponse as MwOrganizationResponse} from '@middleware';

export const landingServiceOrganizationFixtureFactory = lsGetOrganizationResponseMock;
export const middlewareOrganizationFixtureFactory = getGetOrganizationResponseMock;

export const mockMiddlewareOrganizations: MwOrganizationResponse[] = [
  middlewareOrganizationFixtureFactory({
    name: 'CU-Mock',
    full_name: 'University of Colorado Mock',
    entity_id: 'https://mock.identity.oraclecloud.com:443/fed',
    data_enclave_url: null,
    id: fake.string.uuid(),
    email_domains: ['ucmock1.edu', 'ucmock2.edu'],
  }),
  middlewareOrganizationFixtureFactory({
    name: 'VT-Mock',
    full_name: 'Virginia Tech Mock',
    entity_id: 'urn:mace:incommon:vtmock.edu',
    data_enclave_url: 'https://mock_landing_service.vtmock.edu',
    id: fake.string.uuid(),
    email_domains: ['vtmock.edu'],
  }),
  middlewareOrganizationFixtureFactory({
    name: 'UVA-Mock',
    full_name: 'University of Virginia Mock',
    entity_id: 'urn:mace:incommon:virginia-mock.edu',
    data_enclave_url: 'https://localhost:9999',
    id: fake.string.uuid(),
    email_domains: ['virginia-mock.edu'],
  }),
];

export const mockMiddlewareOrganization: MwOrganizationResponse = mockMiddlewareOrganizations[2];
export const mockLandingServiceOrganization: LsOrganizationResponse = landingServiceOrganizationFixtureFactory({
  id: mockMiddlewareOrganization.id,
  name: mockMiddlewareOrganization.name,
  full_name: mockMiddlewareOrganization.full_name,
  email_domains: mockMiddlewareOrganization.email_domains as string[],
});
